import { render, staticRenderFns } from "./CarterasList.vue?vue&type=template&id=1b0870e5&scoped=true&"
import script from "./CarterasList.vue?vue&type=script&lang=js&"
export * from "./CarterasList.vue?vue&type=script&lang=js&"
import style0 from "./CarterasList.vue?vue&type=style&index=0&id=1b0870e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0870e5",
  null
  
)

export default component.exports